import '../../../css/style.css'
import ReactTooltip from 'react-tooltip'

const ReactDataGrid = require('react-data-grid')
const { Cell } = ReactDataGrid
const React = require('react')
const _ = require('lodash')


class InlineEditingCellRenderer extends React.Component {

    getDuplicateCellStyle = () => {
        const rowData = this.props.rowData
        const column = this.props.column
        let gridDuplicateCellStyle = ''
        for (let key in column.rowColorGroups) {
            for (let item = 0; item < column.rowColorGroups[key].length; item++) {
                if (_.includes(column.rowColorGroups[key][item], rowData.RECORD_NUM))
                    gridDuplicateCellStyle = key
            }
        }
        return gridDuplicateCellStyle + ((column.key !== 'DUPLICATE') ? ' ' + this.getCellStyle() : '')
    }
    getCellStyle = () => {
        let rowData = this.props.rowData
        let column = this.props.column
        if (rowData[column.key + '_ORIGIN'] !== undefined && rowData[column.key + '_UI_ERRORS'] && rowData[column.key + '_UI_ERRORS'].length > 0) {
            return 'inline_editing_error_cell'
        } else {
            if (rowData[column.key + '_ORIGIN'] !== undefined && rowData[column.key] !== rowData[column.key + '_ORIGIN']) {
                return 'inline_editing_edited_cell'
            } else {
                const errorRows = rowData.ERRORS.filter(error => error.ATTRIBUTE_NAME === column.key)
                if (errorRows.length > 0) {
                    const anyError = errorRows.filter(error => error.RECORD_TYPE === 'E').length > 0
                    if (anyError) {
                        return 'inline_editing_error_cell'
                    } else {
                        return 'inline_editing_warning_cell'
                    }
                }
            }
            if (this.props.isRowSelected === true) {
                return 'inline_editing_marked_cell'
            } else {
                return 'inline_editing_normal_cell'
            }

        }
    }

    getCellErrors = () => {
        const { rowData, column } = this.props
        const messages = []

        // Backward compatibility with previous per-column UI error shape.
        if (rowData[column.key + '_UI_ERRORS']) {
            messages.push(...rowData[column.key + '_UI_ERRORS'])
        }

        // Build column-level errors from the new row-level ERRORS payload.
        const columnErrors = (rowData.ERRORS || []).filter(error => error.ATTRIBUTE_NAME === column.key)
        columnErrors.forEach(error => {
            if (error.WARNING) {
                messages.push(error.WARNING)
            }

            if (Array.isArray(error.ERRORS)) {
                error.ERRORS.forEach(nestedError => {
                    if (nestedError.DESCRIPTION) {
                        messages.push(nestedError.DESCRIPTION)
                    } else if (nestedError.MSG) {
                        messages.push(nestedError.MSG)
                    }
                })
            }
        })

        const dedupedMessages = _.uniq(messages.map(message => String(message).trim()).filter(Boolean))

        return dedupedMessages
            .map(message => message.replace(/\n/g, '<br/>'))
            .join('<br/>')
    }

    render() {
        const isDupRow = !(_.isEmpty(this.props.rowData.DUP_RECORDS))
        const errors = this.getCellErrors()
        const tooltipId = `cell-tip-${this.props.rowData.RECORD_NUM}-${this.props.column.key}`
        return (
            <div {...(errors ? { 'data-tip': errors, 'data-for': tooltipId } : {})}>
                <Cell {...this.props} className={isDupRow ? this.getDuplicateCellStyle() : this.getCellStyle()} />
                {errors && <ReactTooltip id={tooltipId} type='error' html={true} className='inline_editing_tooltip' />}
            </div>
        )
    }
}


export default InlineEditingCellRenderer
